<template>
  <div>
    <h2><strong>Related Searches</strong></h2>
    <div v-for="item in related.results" :key="item.id">
      <a :href="item._source.url">
        <img
          v-if="item._source['metatag.thumbimage']"
          :src="item._source['metatag.thumbimage']"
        />
        <br />
        {{ item._source.title }}
      </a>
    </div>
  </div>
</template>

<script>
import { getClient } from "@/services/elasticsearch";

export default {
  name: "SearchQueryArtCollection",
  inject: ["runtimeConfig"],
  data() {
    return {
      fromValue: 0,
      sizeValue: 5,
      related: {
        hits: [],
        results: {}
      }
    };
  },
  computed: {
    client() {
      return getClient(this.runtimeConfig.elasticsearch);
    }
  },
  props: {
    term: String
  },
  watch: {
    term() {
      this.elasticSearch();
    }
  },
  mounted() {
    this.elasticSearch();
  },
  methods: {
    async elasticSearch() {
      let self = this;
      try {
        self.related.hits = await client.search({
          index: this.runtimeConfig.elasticsearch.index,
          body: {
            from: self.fromValue,
            size: self.sizeValue,
            query: {
              bool: {
                filter: [
                  {
                    bool: {
                      should: [
                        {
                          match_phrase: {
                            url: "www.getty.edu/art/collection/objects"
                          }
                        }
                      ],
                      minimum_should_match: 1
                    }
                  },
                  {
                    bool: {
                      filter: [
                        {
                          bool: {
                            should: [
                              {
                                multi_match: {
                                  cutoff_frequency: "0.001",
                                  fields: [
                                    "title",
                                    "content",
                                    "metatag.place_created"
                                  ],
                                  query: self.term,
                                  tie_breaker: "0.3",
                                  zero_terms_query: "all"
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            },
            highlight: {
              fields: {
                title: {
                  fragment_size: 150,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                description: {
                  fragment_size: 400,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                content: {
                  fragment_size: 400,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                url: {
                  fragment_size: 200,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                }
              }
            }
          }
        });
        self.related.results = self.related.hits.hits.hits;
      } catch (error) {
        console.log(error.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 50%;
}
</style>
